{
  "name": "@redliner/red-sdk",
  "version": "0.1.0",
  "private": true,
  "license": "UNLICENSED",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "scripts": {
    "build": "tsup",
    "test": "vitest run",
    "typecheck": "tsc -p tsconfig.json --noEmit"
  },
  "dependencies": {
    "@redliner/protocol": "workspace:*"
  },
  "devDependencies": {
    "jsdom": "^25.0.1",
    "tsup": "^8.3.5",
    "typescript": "^5.7.0",
    "vitest": "^2.1.8"
  }
}
